namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmOsoba extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmOsobaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmOsobaObj & GContent;

        // hodnota parametru adx_checkiconad 
        private adxCheckIcoNad: number;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmOsobaObj());
            this.detailObj.createBase({
                contentName: "detailAdmOsoba",
                contentCaption: "jres:32131110",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.adxCheckIcoNad = this.adxCheckIcoNad;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.createZastupyTab());
                tabs.push(this.detailObj.createCertifikatyTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.createZastupyGroup());
                groups.push(this.detailObj.createCertifikatyGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmOsoba", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmOsobaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmOsobaReadDto> {
        adxCheckIcoNad: number;
        povoleniUrovnePristupu: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.tit_pred} ${this.data.jmeno} ${this.data.prijmeni} ${this.data.tit_za}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_ref}`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmOsobaSaveDto, close: boolean) {
            this.cnt.isl.AdmOsoba.upsert({ data: data }).get().then((output: any) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsref");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false);
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmOsoba", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmOsoba.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true,
                    visible: this.options.newRecord == false,
                    type: "static",
                    caption: "jres:33000138",
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actUrovnePristupuOsoby },
                        { action: this.cnt.actions.actFunkcniMistaOsoby },
                        { action: this.cnt.actions.actOpenSeznamAdmOsobaCertifikat }
                    ]
                },
                {
                    favorite: true,
                    type: "static",
                    visible: this.options.newRecord == false,
                    caption: "jres:33000783",
                    icon: "gi-settings",
                    children: [
                        { action: this.cnt.actions.actChangeCredentials },
                        { action: this.cnt.actions.actChangeAltCredentials },
                        { action: this.cnt.actions.actDeleteUserSettins }
                    ]
                },
                this.createShareActions(),
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actChangeCredentials: {
                    icon: "fa-unlock-alt",
                    caption: "jres:33000017",
                    enabled: this.data.Permissions?.CanWrite.value == true && this.options.newRecord == false,
                    run: () => {
                        this.changeCredentials();
                    }
                },
                actChangeAltCredentials: {
                    icon: "fa-unlock-alt",
                    enabled: this.data.Permissions?.CanWrite.value == true && this.options.newRecord == false,
                    caption: "jres:33000020", //RC 33000020 : Zm�na alt. p�ihla�ovac�ch �daj�
                    run: () => {
                        this.changeAltCredentials();
                    }
                },
                actOpenSeznamAdmOsobaCertifikat: {
                    icon: "gi-certif",
                    caption: "jres:29809557", //RC 29809557 : P�i�azen� certifik�tu
                    run: () => {
                        this.openSeznamAdmOsobaCertifikat();
                    }
                },
                actDeleteUserSettins: {
                    icon: "fa-cogs",
                    //enabled: this.data.Permissions?.CanWrite.value == true && this.options.newRecord == false,
                    caption: "jres:33000062", //RC 33000062 : Smazat u�ivatelsk� nastaven� aplikac�
                    run: () => {
                        //this.deleteuserSettings();
                        this.deleteUserSettingsNew();
                    }
                },
                actUrovnePristupuOsoby: {
                    icon: "fa-link",
                    enabled: this.povoleniUrovnePristupu == true,
                    caption: "jres:33000693",
                    run: () => {
                        this.urovnePristupuOsoby();
                    }
                },
                actFunkcniMistaOsoby: {
                    icon: "fa-link",
                    caption: "jres:33000925",
                    run: () => {
                        this.funkcniMistaOsoby();
                    }
                },
                actOpenDetailAdmSpisovyUzel: {
                    icon: "gi-detail",
                    caption: "jres:29931149",
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openDetailSpisovyUzel();
                    }
                },
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actChangeCredentials?.update({ enabled: editMode == false && this.data.Permissions?.CanWrite.value && this.options.newRecord == false })
            this.cnt.actions.actChangeAltCredentials?.update({ enabled: editMode == false && this.data.Permissions?.CanWrite.value && this.options.newRecord == false })
            this.cnt.actions.actDeleteUserSettins?.update({ enabled: editMode == false && this.data.Permissions?.CanWrite.value && this.options.newRecord == false })
            this.cnt.actions.actOpenSeznamAdmOsobaCertifikat?.update({ enabled: editMode == false })
            this.cnt.actions.actUrovnePristupuOsoby?.update({ enabled: editMode == false })
        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1"
            this.MakeSection("");
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), {
                model: "model.ico=value.ico",
                flag: this.createFlagNemenne()
            });
            this.MakeField("ixs_ref", {
                flag: this.createFlagNemenne()
            });
            this.MakeField("jmeno");
            this.MakeField("prijmeni");
            this.MakeField("tit_pred");
            this.MakeField("tit_za");
            this.MakeField("oc");
            this.MakeField("rc");

            this.MakeSection("");
            this.MakeField("zkratka");
            this.MakeField("poznamka");
            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                model: "model.ico=>value.ico,model.ixs_su=value.ixs_su",
                serverFilters: {
                    aktivita: null,
                    ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                },
                dropdown: false,
                change: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailAdmSpisovyUzel?.update({ enabled: ctx.value != null })
                },
                verticalButtons: false,
                buttons: [
                    { action: this.cnt.actions.actOpenDetailAdmSpisovyUzel }
                ]
            });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" });
            this.MakeField("dat_od");
            this.MakeField("dat_do");
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });

            this.MakeSection("jres:32131160"); //RC 32131160 : Kontakt
            this.MakeField("mail");
            this.MakeField("tel");
            this.MakeField("tel_privat");
            this.MakeField("tel_mobil");
            this.MakeField("mail");
            this.MakeField("mail_public");

            this.MakeSelectField("priz_int", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_int=value.priz_an" });
            this.MakeSection("jres:32131162"); //RC 32131162 : Intern� prim�rn� ��et
            this.MakeSelectField("typ_aut", Gordic.Prefabs.Select.ginctau(), { model: "model.typ_aut=value.typ_aut" });
            this.MakeField("login_name_grant");
            this.MakeField("poc_dni_exp");
            this.MakeField("dat_exp");
            this.MakeBoolField("priz_totp");

            this.MakeSection("jres:32131163"); //RC 32131163 : Alternativn� ��et
            this.MakeSelectField("typ_aut2", Gordic.Prefabs.Select.ginctau(), { model: "model.typ_aut2=value.typ_aut" });
            this.MakeField("login_name_grant2");
            this.MakeField("dat_exp2");

            this.MakeSection("jres:32131161"); //RC 32131161 : Extern� ��et
            this.MakeSelectField("priz_ext", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_ext=value.priz_an" });
            this.MakeField("login_name_ext");
        }

        private openSeznamAdmOsobaCertifikat() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmOsobaCertifikat", { ixs: this.data.ixs_ref, ID: "SeznamAdmOsobaCertifikat" })
        }

        private urovnePristupuOsoby() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmUrovenPristupuOsoby", { ixs_ref: this.data.ixs_ref }], { ID: "SeznamAdmUrovenPristupuOsoby" })
        }

        private deleteuserSettings() {
            this.cnt.beginOperation();
            this.cnt.isl.AdmOsoba.deleteAppUserSettings({ ixs_ref: this.data.ixs_ref }).getData().then(() => {
                this.cnt.notification("showToast", {
                    title: this.options.contentCaption,
                    content: "jres:33000060",
                    state: "success",
                    icon: "fa-check-circle"
                })
            }).catch(() => {
                this.cnt.showFlash({
                    content: `${this.options.contentCaption} - jres:33000061`,
                    state: "error",
                    id: "save-error"
                })
            }).always(() => {
                this.cnt.endOperation();
            });
        }

        private deleteUserSettingsNew() {
            if (this.data.ixs_ref) {
                this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogDeleteUserSettings, {
                    osoby: [this.data.ixs_ref],
                    rezimDialog: Gordic.Adm.WebControls.RezimDialog.osoba,
                    openFromDetail: true,
                }], {}, {
                    width: 600,
                    height: 400
                });
            }
        }

        // TABY

        createZastupyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-zastupy",
                    title: "jres:32131159",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-zastupy" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamZastup",
                    serverParams: {
                        ID: "SeznamZastup",
                        ixs_ref: this.data.ixs_ref,
                        tabOpen: true
                    }
                }
            }
        }

        createCertifikatyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-certifikaty",
                    title: "jres:29809557", //RC 33000925 : Funk�n� m�sta zast�van� osobou
                    opened: true,
                    locked: true,
                    group: { id: "_tab-certifikaty" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmOsobaCertifikat",
                    serverParams: {
                        ID: "SeznamAdmOsobaCertifikat",
                        ixs: this.data.ixs_ref,
                        tabOpen: true,
                    }
                }
            }
        }

        createZastupyGroup(): IGTabGroupOptions {
            return { id: "_tab-zastupy", caption: "jres:32131159" }
        }
        createCertifikatyGroup(): IGTabGroupOptions {
            return { id: "_tab-certifikaty", caption: "jres:29809557" }
        }


        // END TABY

        private funkcniMistaOsoby() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMisto", { ixs_ref: this.data.ixs_ref })
        }

        private changeCredentials() {
            this.cnt.dialogs.showModalWindow("Gordic.Adm.WebControls.ChangeLoginModalWindow", { ixs_ref: this.data.ixs_ref }, { height: 500, width: 700 }).on("close", (o, reload) => {
                if (reload == true)
                   this.reloadDataBase();
            })
        }

        private changeAltCredentials() {
            this.cnt.dialogs.showModalWindow("Gordic.Adm.WebControls.ChangeAltLoginModalWindow", { ixs_ref: this.data.ixs_ref }, { height: 500, width: 700 }).on("close", (o, reload) => {
                if (reload == true)
                   this.reloadDataBase();
            })
        }

        private openDetailSpisovyUzel() {
            const spisUzel = this.cnt.findFields("ixs_su").gfield("getValue");
            if (spisUzel != null)
                this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmSpisovyUzel"], { ID: "DetailAdmSpisovyUzel", newRecord: false, ixs_su: spisUzel.ixs_su }, { width: 1000, height: 600 })
        }
    }
}



